// src/redux/sagas/projetSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";
import {
    FETCH_MY_PROJETS_REQUEST,
    fetchMyProjetsSuccess,
    fetchMyProjetsFail,

    FETCH_ALL_PROJETS_REQUEST,
    fetchAllProjetsSuccess,
    fetchAllProjetsFail,

    CREATE_PROJET_REQUEST,
    createProjetSuccess,
    createProjetFail,

    UPDATE_PROJET_REQUEST,
    updateProjetSuccess,
    updateProjetFail,

    DELETE_PROJET_REQUEST,
    deleteProjetSuccess,
    deleteProjetFail,

    fetchAllProjetsRequest,
} from "../actions/projetActions";

const extractErr = (e, fallback) =>
    e?.response?.data?.message || e?.message || fallback;

export function* fetchMyProjetsSaga() {
    const url = `${API_BASE_URL}/api/projets/my-projects`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchMyProjetsSuccess(resp.data || []));
    } catch (error) {
        yield put(fetchMyProjetsFail(extractErr(error, "Erreur chargement projets")));
    }
}

export function* fetchAllProjetsSaga() {
    const url = `${API_BASE_URL}/api/projets`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchAllProjetsSuccess(resp.data || []));
    } catch (error) {
        yield put(fetchAllProjetsFail(extractErr(error, "Erreur chargement projets")));
    }
}

export function* createProjetSaga(action) {
    const url = `${API_BASE_URL}/api/projets`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    try {
        const resp = yield call(postRequest, { url, token, headers: { uid }, data: action.payload });
        yield put(createProjetSuccess(resp.data));
        yield put(fetchAllProjetsRequest());
        yield call([Swal, Swal.fire], {
            icon: "success", text: "Projet créé avec succès", timer: 1400, showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErr(error, "Erreur création projet");
        yield put(createProjetFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    }
}

export function* updateProjetSaga(action) {
    const { id, data } = action.payload;
    const url = `${API_BASE_URL}/api/projets/${id}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    try {
        const resp = yield call(putRequest, { url, token, headers: { uid }, data });
        yield put(updateProjetSuccess(resp.data));
        yield put(fetchAllProjetsRequest());
        yield call([Swal, Swal.fire], {
            icon: "success", text: "Projet modifié avec succès", timer: 1400, showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErr(error, "Erreur modification projet");
        yield put(updateProjetFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    }
}

export function* deleteProjetSaga(action) {
    const url = `${API_BASE_URL}/api/projets/${action.payload}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    try {
        yield call(deleteRequest, { url, token, headers: { uid } });
        yield put(deleteProjetSuccess(action.payload));
        yield put(fetchAllProjetsRequest());
        yield call([Swal, Swal.fire], {
            icon: "success", text: "Projet supprimé", timer: 1400, showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErr(error, "Erreur suppression projet");
        yield put(deleteProjetFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    }
}

export default function* watchProjetSagas() {
    yield takeLatest(FETCH_MY_PROJETS_REQUEST, fetchMyProjetsSaga);
    yield takeLatest(FETCH_ALL_PROJETS_REQUEST, fetchAllProjetsSaga);
    yield takeLatest(CREATE_PROJET_REQUEST, createProjetSaga);
    yield takeLatest(UPDATE_PROJET_REQUEST, updateProjetSaga);
    yield takeLatest(DELETE_PROJET_REQUEST, deleteProjetSaga);
}
